import { Component, Input } from '@angular/core';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-service-err-modal',
  templateUrl: './service-err-modal.component.html',
  styleUrls: ['./service-err-modal.component.scss']
})
export class ServiceErrModalComponent {
  @Input() titulo: string = 'Error en el servicio'
  @Input() servicio: string = ''
  @Input() codigo: string = ''
  @Input() mensaje: string = ''

  constructor(
    private _utils: UtilsService
  ) { 
    this._utils.getServiceErrorModalData.subscribe(
      (res: any) => {
        if ( res ) {
          this.servicio = res.servicio ?? ''
          this.codigo = res.codigo ?? ''
          this.mensaje = res.mensaje ?? ''
        }
      }
    )
  }

  setServicio(servicio: string) {
    this.servicio = servicio
  }

}
